import React, { useEffect } from "react";
import { MapContainer, TileLayer } from "react-leaflet";
import * as Constants from "../../consts/Constants.js";
import L from "leaflet";
import "leaflet.heat";

export default function MapVisit({ data }) {
  const [center, setCenter] = React.useState({
    lat: Constants.LATITUD_AYACUCHO,
    lng: Constants.LONGITUD_AYACUCHO,
  });

  const [map, setMap] = React.useState(null);
  const [layer, setLayer] = React.useState(null);

  useEffect(() => {
    if (map != null) {
      const points = data
        ? data.map((p) => {
            return [p.latitude, p.longitude];
          })
        : [];
      map.eachLayer(function (layer) {
        if (layer._heat !== undefined) {
          map.removeLayer(layer);
        }
      });
      L.heatLayer(points, {
        radius: 10, // default value
        blur: 15, // default value
      }).addTo(map);
    }
  }, [map, data]);

  return (
    <div
      style={{
        width: "50%",
      }}
    >
      <MapContainer
        style={{
          height: "100%",
          width: "100%",
          zIndex: 399,
        }}
        center={center}
        zoom={13}
        scrollWheelZoom={true}
        whenCreated={setMap}
      >
        <TileLayer
          attribution='&copy; <a href="http://osm.org/copyright">OpenStreetMap</a> contributors'
          url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
        />
      </MapContainer>
    </div>
  );
}
